/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import styled, {css} from 'styled-components';
import Colors from 'constants/Colors';
import {FontWeight, FiraSansBold} from 'components/Text';
import {darken} from 'polished';
import {Breakpoints} from "../../../../constants/Breakpoints";
import Button from 'components/Button';
import { Field } from 'formik'
import { mediaHelperMaxWidth, mediaHelper } from "../../../../utils/src";
import { Row } from 'components/Grid';
import Label from "components/Form/Label";


const generateStyle = (color, bg, bgFocus, bgActive, args = []) => {
  return css`
  color: ${color};
  background-color: ${bg};
  box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.1);
  &:hover:not(:disabled),
  &:focus:not(:disabled) {
    background-color: ${bgFocus};
    box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.2);
  }
  &:active:not(:disabled) {
    background-color: ${bgActive};
  }
  ${args.length >= 1 ? args.join('\n') : ''}
  `;
}
export const AddButton = styled.button`
  display: flex;
  width:50px;
  height:50px;
  border: 0px;
  background-color:transparent;
  cursor: pointer;
  align-self: center;
`;

const primaryMixin = generateStyle(Colors.WHITE, Colors.BLUE, darken(0.1, Colors.BLUE), darken(0.2, Colors.BLUE));

export const ButtonContent = styled.div`
  display:  flex;
  background-color: ${Colors.WHITE};  
  flex-direction: row;
  justify-content: space-evenly;
  
  @media (max-width: ${Breakpoints.lg}) {  
    flex-wrap: wrap;
    padding-right: 10px;
    width: 100%;
  }
`;

export const Title = styled.label`
  font-size: 16px;
  color: ${Colors.GRAY[6]};
  ${FiraSansBold}
`;

export const LabelEdit = styled(Label)`
  font-size: 12px;

  @media screen and (max-width: ${Breakpoints.sm}) {
    width: unset;
    text-align: center;
  }
`;

export const TableContainer = styled.div`
  width:100%;
  margin-left:20px;
`;

export const ScrollBox = styled.div` 
  overflow-y: auto;
  overflow-x: hidden;

  padding:10px 20px 10px 0px;
  // max-height: 500px;
  
  ::-webkit-scrollbar{
    background:${Colors.WHITE};
    width:8px;
  }
  ::-webkit-scrollbar-thumb {
    background: ${Colors.GRAY[3]};
    border-radius: 15px;
  }
  `;

export const Text = styled.text`
  color:${props => props.secundary ? Colors.BLUE : Colors.GRAY[6]};
  font-weight: ${FontWeight.SemiBold};
  font-size: 16px;
  cursor: pointer;

  @media screen and (max-width: ${Breakpoints.sm}) {
    font-size: 12px;
  }

  @media screen and (max-width: ${Breakpoints.xxl}) {
    font-size: 12.5px;
  }

  ${({ fontSize})=> fontSize && `font-size: ${fontSize}px;` }
`;

export const DialogSelect = styled.div`
  width: 100%;  
  margin: 30px 0px 10px 0px;
`;

export const DialogConfirm = styled.button`
  width: calc(50% - 10px);
  margin-left: 10px;
  height: 40px;
  background: ${Colors.BLUE};
  border: 0px;
  border-radius: 5px;
  font-weight: 600;
  text-transform: uppercase;
  color: #fff;
  cursor: pointer; 
`;


export const DialogCancel = styled.button`
  width: calc(50% - 10px);
  margin-right: 10px;
  height: 40px;
  background: ${Colors.GRAY[0]};
  border: 0px;
  border-radius: 5px;
  font-weight: 600;
  text-transform: uppercase;
  color: #fff;
  cursor: pointer;     
`;

export const DialogRejected = styled.button`
  width: calc(50% - 10px);
  margin-right: 10px;
  height: 40px;
  background: ${Colors.GRAY[6]};
  border: 0px;
  border-radius: 5px;
  font-weight: 600;
  text-transform: uppercase;
  color: #fff;
  cursor: pointer;     
`;

export const Line = styled.div`
  width: 98.4%;
  height: 2px;
  background-color: ${Colors.GRAY[4]};
  margin: 0 auto;
`;
export const BorderSwitch = styled.div`  
  background: ${Colors.GRAY[6]};
  padding-left: 1px;
  border-radius: 14px;
  width: 57px;
  padding-top: 1px;
  height: 30px;
  display: -webkit-inline-box;
  margin-left: 20px;

  ${({ newBorder }) =>
    newBorder
      ? css`
          margin-top: 10px;
        `
      : ""}
`;

export const CalendarContainer = styled.div`
  z-index: 55;
  left: 45px;
  position: relative;
`;
export const TotalValueContainer = styled.div`
  width: 20%;
  margin-left:20%;
  display: flex;
justify-content: flex-start;
align-items: flex-start;
flex-direction: column;
  @media screen and (max-width: 768px) { 
    width: 65%;
  margin-left:45%;
  }
`;
export const HrTotal = styled.hr`
  width: 90%;
  @media screen and (max-width: 768px) { 
    width: 65%;
  }
`;
export const TotalContainer = styled.div`
width:90%
display: flex;
justify-content: center;
align-items: center;
flex-direction: column;
`;

export const TagInput = styled.input`
  flex: 1;
  display: none;
  border: none;
  width: 100%;

  &:focus {
    outline: transparent;
  }
`;

export const PlaceHolder = styled.label`
  display: block;
  padding: 0.75rem 3.75rem;
  text-transform: uppercase;
  -webkit-letter-spacing: -0.5px;
  -moz-letter-spacing: -0.5px;
  -ms-letter-spacing: -0.5px;
  letter-spacing: -0.5px;
  font-size: 16px;
  height: 42px;
  width: auto;
  white-space: nowrap;
  font-weight: bold;
  font-style: normal;
  border: 0 none;
  border-radius: 8px;
  background: transparent;
  cursor: pointer;

  transition: background-color 0.15s ease, color 0.15s ease, width 0.3s ease,
    border 0.5s ease, border-color 0.5s ease, box-shadow 0.15s ease;
  text-align: center;

  color: #ffffff;

  box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.1);
  margin-left: 10px;

  text-align: center;
    ${primaryMixin}

    ${({ disabled }) =>
    disabled
      ? css`
        opacity: 0.4;
        cursor: not-allowed;
        `
      : ""}
`;

export const NewButton = styled(Button)`
  @media screen and (max-width: 1580px) { 
    margin-top: 8px;
  }
`;

export const FieldGrid = styled(Field)`
  border-radius: 4px;
  padding-left: 5px;
  vertical-align: middle;
`;

export const ColIcon = styled.div`
  display: flex;
  margin: 0px;
  padding: 5px;
  justify-content: flex-start;
  align-items: center;
`;

export const TableHeader = styled.th`
  ${({ minWidth }) => minWidth ? `min-width: ${minWidth}px` : ''}
  ${({ maxWidth }) => maxWidth ? `width: ${maxWidth}px` : ''}
  position: relative;
  vertical-align: top;
  padding: 5px;
  padding-left: 0px;
  text-align: left;
  span {
    font-size: 13px !important;
  }

  &:last-child { 
    text-align: right;
  } 
`;

export const TableColumn = styled.td`
  vertical-align: top;
  text-align: left;
  padding-bottom: 8px;
  padding-top: 8px;
  padding-right: 5px;
  display: table=cell;
  text-align: left;

  &:last-child {
    padding-right: 0px;
  }

  @media screen and (max-width: ${Breakpoints.sm}) {
    display: flex;
    max-width: unset !important;
    padding-top: 0px;
    padding-bottom: 2px;

    &:last-child {
      padding-bottom: 10px;
    }

    &:first-child {
      padding-top: 10px;
    }
  }
`;

export const Content = styled.div`
  background-color: ${Colors.WHITE};
  border: 1px solid ${Colors.BLUE};
  margin: 0;
  border-radius: 10px;
  box-shadow: 0px 17px 17px 6px #5f5f5f1a;
  
  @media screen and (min-width: ${Breakpoints.sm}) {
    margin-top: 40px;
    margin-bottom: 10%;
    border-radius: 15px;
  }
  
  ${mediaHelper.md`
    border-radius: 20px;
  `}
`;

export const InlineLabel = styled(Text)`
  display: inline-block;
  width: 35%;
  vertical-align: middle;
  padding-right: 5px;
  justify-content: start;
  align-items: flex-start;
  justify-self: flex-start;
  text-align: left;
  font-size: 13px;
  color: ${Colors.GRAY[3]};
  

  @media screen and (min-width: 601px) {
    display: none;
  }
`;

export const LoadContainer = styled.div`
  display: flex;
  justify-content: center;
  padding: 28px;
`;


export const MobileLabel = styled.span`
  font-weight: ${FiraSansBold};
  text-transform: uppercase;
  font-size: 16px;
  color: ${Colors.GREEN};
`;

export const RowFilterOrder = styled.div`
  display: none;

  @media (max-width: ${Breakpoints.md}) {
    display: flex;
    flex-direction: column;
    border-radius: 10px 10px 0 0;
    display: flex;
    width: 95%;
    margin-bottom: 10px;
  }
`;

export const TableHead = styled.thead`
  @media screen and (max-width: 600px) {
    border: none;
    clip: rect(0 0 0 0);
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    width: 1px;
  }
`;

export const TableRow = styled.tr`

`;

export const TableBody = styled.tbody`
tr {
    border-bottom: 3px solid #E0E0E0;
  }
`;

export const Table = styled.table`
  border-collapse: collapse;
  padding: 0;
  width: 100%;
`;

export const RowLockAndSave = styled(Row)`
  @media (max-width: ${Breakpoints.sm}) {
    margin-top: 35px;
  }
`